import { Spin, Modal } from 'antd';
import React, { useState } from 'react';
import { addCourseOffer } from '../../services/courseOfferService';
import CourseOfferForm from './CourseOfferForm';
import { validateLinks } from '../../utilities/formValidator';

function CourseOfferAdd({
  isOpen,
  courses,
  cohortCourses,
  isPricingModalVisible,
  setIsPricingModalVisible,
  onCancelModal
}) {
  const initialValues = {
    courseId: '',
    code: '',
    description: '',
    courseOfferStatus: '',
    startDate: '',
    endDate: '',
    frequency: [],
    minRegistrations: 0,
    maxRegistrations: 0,
    trainers: [],
    location: '',
    whereToGo: '',
    calendarLink: '',
    whatToBring: '',
    classMaterialsLink: '',
    courseFees: 0,
    deposit: 0,
    generalNotes: '',
    showPrice: true,
    isSpecial: false,
    specialMessage: '',
    whatsappGroupLinks: null,
    discordGroupLink: '',
    communityPlatforms: []
  };

  const [status, setStatus] = useState({
    type: 'IDLE',
    message: 'In idle mode'
  });

  const validateDate = (startDate, endDate) => {
    return new Date(startDate).getTime() < new Date(endDate).getTime();
  };

  const validateMaxAndMin = (max, min) => {
    return max >= min;
  };

  const onSubmit = async (values) => {
    console.log('Initial values!!', values);
    let payload = {
      ...values,
      startDate: values.startDate.utc().format(),
      endDate: values.endDate.utc().format()
    };

    if (payload.setReleaseDate) payload.releaseDate = payload.startDate;
    else payload.releaseDate = null;

    if (!validateDate(payload.startDate, payload.endDate)) {
      setStatus({
        type: 'ERROR',
        message: 'Start date cannot be after end date!'
      });
    } else if (
      !validateMaxAndMin(
        payload.maxRegistrations,
        payload.minRegistrations
      )
    ) {
      setStatus({
        type: 'ERROR',
        message: 'Max Registrations cannot be less than Min Registrations!'
      });
    } else if (!validateLinks(payload.whatsappGroupLinks, true)) {
      setStatus({
        type: 'ERROR',
        message: 'Whatsapp Link is not valid'
      });
    } else {
      setStatus({ type: 'LOADING', message: 'Request in Progress!' });
      await addCourseOffer(payload)
        .then((response) => {
          console.log('Successfully Added! ', response);
          setStatus({
            type: 'SUCCESS',
            message: 'Data added successfully!'
          });
        })
        .catch((error) => {
          alert('Getting data from the backend failed!');
          if (error?.response?.data?.message)
            setStatus({
              type: 'ERROR',
              message: error.response.data.message
            });
          else
            setStatus({ type: 'ERROR', message: 'Something went wrong!' });
        });
    }
  };
  return (
    <Modal
      title={`Add Course Offer`}
      visible={isOpen}
      onCancel={() => onCancelModal()}
      footer={null}>
      {status.type === 'LOADING' ? (
        <Spin size="large" />
      ) : (
        <CourseOfferForm
          type="Add"
          initialValues={initialValues}
          onSubmit={onSubmit}
          status={status}
          visible={isOpen}
          courses={courses}
          cohortCourses={cohortCourses}
          isPricingModalVisible={isPricingModalVisible}
          setIsPricingModalVisible={setIsPricingModalVisible}
        />
      )}
    </Modal>
  );
}
export default CourseOfferAdd;
